import * as ActionTypes from "constants/ActionTypes";

export const setPlayerOptions = (playerOptions) => ({
  type: ActionTypes.SET_PLAYER_OPTIONS,
  playerOptions,
});
